import { render, staticRenderFns } from "./MatchWinner.vue?vue&type=template&id=07317072&scoped=true&"
import script from "./MatchWinner.vue?vue&type=script&lang=js&"
export * from "./MatchWinner.vue?vue&type=script&lang=js&"
import style0 from "./MatchWinner.vue?vue&type=style&index=0&id=07317072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07317072",
  null
  
)

export default component.exports